import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const getBomTypeGroup = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_TYPE_GROUP.GET}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addBomTypeGroup = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.BOM_TYPE_GROUP.CREATE}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchBomTypeGroupById = async (bomTypeGroupId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_TYPE_GROUP.GET_BY_ID}${bomTypeGroupId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateBomTypeGroup = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.BOM_TYPE_GROUP.UPDATE}${payload._id}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteBomTypeGroup = async (payload) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.BOM_TYPE_GROUP.DELETE}`, {
      data: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
